import axios from 'axios';

const buscaCEP = async cep => {
    cep = cep.replace(/-/g, "");

    return axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        .then(res => {
            let address = res.data;
            if (address.erro) return null;

            address.logradouro = removeAcento(address.logradouro).toUpperCase();
            address.bairro = removeAcento(address.bairro).toUpperCase();
            address.uf = address.uf.toUpperCase()
            address.localidade = removeAcento(address.localidade).toUpperCase();
            return address;
        })
}

const removeAcento = (text) => {
    text = text.toLowerCase();
    text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
    text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
    text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
    text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
    text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
    text = text.replace(new RegExp("[Ç]", "gi"), "c");
    return text;
}

export default {
    buscaCEP
}